// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExemptionChangeRejectionReason {
  OverlappingExemptionExists = "OVERLAPPING_EXEMPTION_EXISTS",
  WarningBypassingForbidden = "WARNING_BYPASSING_FORBIDDEN",
}
export default ExemptionChangeRejectionReason;
